import { MarkerClustererOptions } from "@googlemaps/markerclustererplus";

export const splitUpText = (text: string) => (
    text
        .split("\n")
        .map((v) => `<div>${v}</div>`)
        .join("")
);

// Bit of js magic going on here
// So each marker will have an onclick event , and there will be a closure instance
// for that marker, in that closure is where state will be held for if the info window
// is open or not. The closure will get reset when the markers
// are recreated (when the options are updated)
export const addModalTextToMarker = (
    modalText: string,
    googleMap: google.maps.Map,
    marker: google.maps.Marker,
) => {
    const infoWindow = new google.maps.InfoWindow({
        content: splitUpText(modalText),
    });

    let open = false;

    marker.addListener("click", () => {
        if (open) {
            infoWindow.close();
            open = false;
        } else {
            infoWindow.open(googleMap, marker);
            open = true;
        }
    });

    return infoWindow;
};

export const defaultClusterOptions = (
    icon: string,
    minimumClusterSize: number,
    className?: string,
): MarkerClustererOptions => (
    // weird quirk with google marker cluster library, they automatically
    // append 1.[ext] to the imagePath so we have to add a 1.png
    // and remove it from the image path
    {
        imagePath: icon.replace("1.png", ""),
        imageExtension: "png",
        clusterClass: `Cluster ${className || ""}`,
        enableRetinaIcons: true,
        minimumClusterSize,
        gridSize: 30,
    });
